/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAccessGovernance extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAccessGovernance");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAccessGovernance.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAccessGovernance>): BackgroundJobPayloadForAccessGovernance {
        let obj = Object.assign(new BackgroundJobPayloadForAccessGovernance(), model);
        BackgroundJobPayloadForAccessGovernance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAccessGovernance>): BackgroundJobPayloadForAccessGovernance {
        if (!model) return null;
        return BackgroundJobPayloadForAccessGovernance.newInstance(<BackgroundJobPayloadForAccessGovernance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAccessGovernance) {
        if (!obj) return;

        models.BackgroundJobPayloadForAccessGovernance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAccessGovernance): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAccessGovernance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud Account ID
     */
    cloud_account_id: string;

}
